import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import api, { fmtError } from "@/lib/api";
import { toast } from "sonner";

export default function Auth() {
  const { setUser } = useApp();
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const url = mode === "login" ? "/auth/login" : "/auth/register";
      const { data } = await api.post(url, form);
      setUser(data.user);
      toast.success(mode === "login" ? "Welcome back." : "Your account has been created.");
      navigate(data.user.role === "admin" ? "/admin" : "/account");
    } catch (err) { toast.error(fmtError(err.response?.data?.detail)); }
    setLoading(false);
  };

  const inp = "w-full h-12 px-4 border bg-transparent outline-none text-sm mb-3 focus:border-[var(--ev-text)]";

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-20">
      <div className="w-full max-w-md">
        <h1 className="font-serif text-4xl text-center mb-2">{mode === "login" ? "Sign In" : "Create Account"}</h1>
        <p className="text-center text-sm mb-10" style={{ color: "var(--ev-muted)" }}>
          One account across the entire Maison Évaren.
        </p>
        <form onSubmit={submit}>
          {mode === "register" && (
            <input data-testid="auth-name" required placeholder="Full name" className={inp} style={{ borderColor: "var(--ev-border)" }}
              value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          )}
          <input data-testid="auth-email" required type="email" placeholder="Email address" className={inp} style={{ borderColor: "var(--ev-border)" }}
            value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          <input data-testid="auth-password" required type="password" placeholder="Password" className={inp} style={{ borderColor: "var(--ev-border)" }}
            value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
          <button data-testid="auth-submit" disabled={loading} className="btn-luxe w-full mt-3">
            {loading ? "Please wait…" : mode === "login" ? "Sign In" : "Create Account"}
          </button>
        </form>
        <button data-testid="auth-toggle" onClick={() => setMode(mode === "login" ? "register" : "login")}
          className="w-full text-center text-sm mt-6 ev-link" style={{ color: "var(--ev-muted)" }}>
          {mode === "login" ? "New to Évaren? Create an account" : "Already have an account? Sign in"}
        </button>
      </div>
    </div>
  );
}
